import * as React from 'react';
import { connect } from 'react-redux';
import { returntypeof } from 'react-redux-typescript';
import { LocaleProvider } from 'antd';
import { IntlProvider } from 'react-intl';
import { getLocaleMessage, getFormats, getAppLocale } from 'utils/intl';
import * as parser from 'query-string';
import { changeLocale } from 'actions';

const mapStateToProps = (state: RootState) => ({
  locale: state.i18n.locale,
});

const mapDispatchToProps = {
  changeLocale,
};

const stateProps = returntypeof(mapStateToProps);
type StateProps = typeof stateProps;
type MapDispatchToProps = typeof mapDispatchToProps;
type Props = StateProps & MapDispatchToProps;

/**
 * This component allows us to set language dynamically, by reading
 * `locale` state from redux store.
 */
class ConnectedLocale extends React.Component<Props> {
  shouldComponentUpdate(nextProps: Props) {
    return nextProps.locale !== this.props.locale;
  }

  componentDidMount() {
    const lang = parser.parse(window.location.search).lang;
    if (lang) {
      this.props.changeLocale(lang);
    }
  }

  render() {
    // convert browser's locale using getLocaleMessage() method from our utils/intl wrapper
    // and IntlProvider doesn't always handle 'en-US', 'en-SG' cleanly
    // https://github.com/yahoo/react-intl/issues/204
    const appLocale = getAppLocale(this.props.locale);
    const { localMsg, antdMsg } = getLocaleMessage(appLocale);
    return (
      <LocaleProvider locale={antdMsg}>
        <IntlProvider
          locale={appLocale}
          key={appLocale}
          messages={localMsg}
          formats={getFormats()}
        >
          {this.props.children}
        </IntlProvider>
      </LocaleProvider>
    );
  }
}

export default connect<StateProps, MapDispatchToProps, void>(
  mapStateToProps,
  mapDispatchToProps
)(ConnectedLocale);



// WEBPACK FOOTER //
// ./app/containers/ConnectedLocale.tsx